export default __webpack_public_path__ + "static/media/rendertotexture.d6dd8e87.frag";